import MLSystemIcon from "../../Icon-SVG/MLSystemIcon";
import Spinner from "../Spinner/Spinner";

import "./styles.scss";

const GenerateAiDecisionButton = ({ onClick, loading = false, disabled = false }) => {
  const isDisabled = loading || disabled;

  const clickHandler = () => {
    // Guard the handler too, so a queued click can not fire a second request
    if (isDisabled) return;
    onClick();
  };

  return (
    <button
      type="button"
      className={`ai-decision-button ${isDisabled ? "ai-decision-button--disabled" : ""}`}
      disabled={isDisabled}
      onClick={clickHandler}>
      {loading ? "Generating..." : "Generate AI Decision"}
      {loading ? (
        <Spinner width={16} height={16} />
      ) : (
        <MLSystemIcon color="white" width={18} />
      )}
    </button>
  );
};

export default GenerateAiDecisionButton;
